import { Box, Typography } from '@mui/material';

type FehlerPageDetailPanelProps = {
  readonly titel?: string;
  readonly message: string;
};

export const FehlerPageDetailPanel = ({ titel, message }: FehlerPageDetailPanelProps) => (
  <Box sx={{ width: '100%', px: 14, py: 2 }}>
    <Box display="flex" flexDirection="row">
      <Box display="flex" flexDirection="column" gap={1} mr={4} width="400px" minWidth="400px">
        <Typography variant="paragraphSm" color="text.secondary">
          Veranstaltung
        </Typography>
        <Typography>{titel ?? '-'}</Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="paragraphSm" color="text.secondary">
          Fehlerbeschreibung
        </Typography>
        <Typography sx={{ fontSize: '1em' }}>{message}</Typography>
      </Box>
    </Box>
  </Box>
);
